import 'script-loader!intro.js/minified/intro.min.js';

function addStyle(styleId, content) {
    if (document.getElementById(styleId)) {
        return;
    }
    const style = document.createElement('style');
    style.id = styleId;
    style.type = 'text/css';
    style.innerHTML = content;
    document.getElementsByTagName('head')[0].appendChild(style);
}

Hop.defineModule('introjs', (root, param) => {
    const $root = $(root);
    if (!param.acknowledgementPref) {
        throw new Error('Missing parameter "acknowledgementPref"');
    }

    function fixStyle() {
        if (param.dropdown) {
            $('#introjsCssFixParent').remove();
        } else {
            addStyle(
                'introjsCssFixParent',
                '.introjs-fixParent {' +
                    'z-index: auto !important;' +
                    'opacity: 1.0 !important;' +
                    '// position: absolute !important;' +
                    'transform: none !important;' +
                    '}',
            );
        }

        $('#introjsCssOverlay').remove();
        addStyle(
            'introjsCssOverlay',
            '.introjs-overlay {' +
                'z-index: ' +
                (param.dropdown ? '10' : '999999') +
                ';' +
                '}' +
                '.introjs-helperLayer {' +
                'z-index: ' +
                (param.dropdown ? '1' : '9999998') +
                ';' +
                '}',
        );
    }

    function configureTour(tour) {
        tour.setOption('tooltipPosition', 'auto');
        tour.setOption('positionPrecedence', ['left', 'right', 'bottom', 'top']);

        if (!param.dropdown) {
            tour.oncomplete(() => {
                window.scrollTo(0, $('[data-step=1]').scrollTop());
            });
        }

        tour.onafterchange((el) => {
            if ($(el).hasClass('introjsFloatingElement')) {
                $('body').addClass('introjs-start');
            } else {
                $('body').removeClass('introjs-start');
            }

            const $bullets = $('.introjs-bullets').clone();
            $('.introjs-bullets').remove();
            $bullets.insertAfter('.introjs-prevbutton');

            if (typeof window.scrollTo === 'function' && el.offset().top < 100) {
                window.scrollTo(0, 150);
            }
        });

        // skip & exit
        tour.onexit(acknowledgeIntro);
        tour.oncomplete(acknowledgeIntro);

        let steps = [];
        if (param.introstart) {
            steps.push({intro: param.introstart});
        }
        steps = steps.concat(dataStepsArr);

        tour.setOptions({
            showStepNumbers: false,
            nextLabel: param.nextLabel,
            prevLabel: param.prevLabel,
            skipLabel: param.skipLabel,
            doneLabel: param.doneLabel,
            steps: steps,
        });
    }

    function acknowledgeIntro() {
        return $.post('/api/webpref/' + param.acknowledgementPref);
    }

    function shouldStartTour() {
        if (!param.onlyWhen) {
            return true;
        }
        let conditions;
        if (typeof param.onlyWhen === 'string') {
            conditions = [param.onlyWhen];
        } else if (Array.isArray(param.onlyWhen)) {
            conditions = param.onlyWhen;
        } else {
            return true;
        }

        return conditions.every((c) => {
            if (c === 'headerMenuIsOpen') {
                const headerMenu = Hop.getStoreObj('menu');
                if (headerMenu && headerMenu.isMenuOpen) {
                    return true;
                }
            }
            return false;
        });
    }

    function startTour(maybeStep) {
        if (!shouldStartTour()) {
            return;
        }
        param.gtmOnStart && Hop.gtm.push(param.gtmOnStart);
        const tour = window.introJs();
        configureTour(tour);

        fixStyle();

        if (maybeStep && !isNaN(maybeStep)) {
            tour.goToStep(maybeStep);
        }

        if (param.dropdown) {
            $(param.dropdown).dropdown('toggle');
            setTimeout(tour.start.bind(tour), 200);
        } else {
            tour.start();
        }
    }

    $root.find('.btn-introjs').click((e) => {
        e.preventDefault();

        let startStep;
        if (e.target.getAttribute('data-start-at-step')) {
            startStep = parseInt(e.target.getAttribute('data-start-at-step'), 10);
        }

        startTour(startStep);
    });

    const $dataSteps = $root.find('[data-step]');
    const dataStepsArr = [];
    let text = '';

    function stepNotAdded(domEl) {
        return !dataStepsArr.filter((step) => step.index === domEl.getAttribute('data-step')).length;
    }

    $dataSteps.each((idx, el) => {
        text = el.getAttribute('data-intro');

        if (stepNotAdded(el)) {
            dataStepsArr.push({
                intro: text.indexOf('<p>') > -1 ? text : '<p>' + text + '</p>',
                index: el.getAttribute('data-step'),
                element: el,
                position: el.getAttribute('data-position') || 'bottom',
            });
        }
    });

    function triggerTourCheckAndStart() {
        $.get('/api/webpref/' + param.acknowledgementPref).done((alreadyAcknowledged) => {
            if (alreadyAcknowledged) {
                // cleaning
                if (param.cookieName && Hop.getCookie(param.cookieName) !== '') {
                    Hop.setCookie(param.cookieName, '', {expiresInDays: 0});
                }
            } else {
                if (!param.cookieName || Hop.getCookie(param.cookieName) === '') {
                    startTour();
                } else {
                    // acknowledgement was previously stored as a cookie, let's save it server side if present
                    acknowledgeIntro().done(() => {
                        Hop.setCookie(param.cookieName, '', {expiresInDays: 0});
                    });
                }
            }
        });
    }

    if (param.triggerWhen === 'accountMenuIsReady') {
        Hop.events.on('menu:identities-loaded', () => {
            setTimeout(() => {
                triggerTourCheckAndStart();
            }, 500);
        });
    } else {
        setTimeout(() => {
            triggerTourCheckAndStart();
        }, 1000);
    }
});
